export const availableLanguages = ['en_US', 'zh_CN', 'fr_FR', 'ko', 'ja', 'th', 'vi', 'es', 'pt']
